// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appId: "POP",
  appversion: "2.5.50 | 11 Sep 2025", //Update this Before Deploy UAT
  production: false,
  PageSize: 15,
  PageSizeMedium: 10,
  PageSizeSmall: 3,

  //ส่วน Config ระหว่าง Run Localhost กับ Doker
  //base_api: "https://localhost:44346/", //Use this for Dev in Localhost
  //base_api: "http://localhost:8081/",
  //ส่วน Config ระหว่าง Run Localhost กับ Doker

  // Dev
  base_api: "https://pop-api-dev.double-p.co.th/", //Change to this Before Deploy UAT
  // Prod
  //base_api: "https://pop-api.double-p.co.th/",
  // Demo
  //base_api: "https://doublep-cloud.servehttp.com:4017/",
  // Production
  //base_api: "http://doublep-cloud.servehttp.com:4019/",
  //base_api: "http://doublep-cloud.servehttp.com:4021/",
  // Partner
  //base_api: "http://doublep-cloud.servehttp.com:4025/",

  //ส่วน Config ระหว่าง Run Localhost กับ Doker
  // Dev
  token_api: "https://pop-tokenapi-dev.double-p.co.th/", // เปิดอันนี้ run local
  // Prod
  //token_api: "https://pop-tokenapi.double-p.co.th/",
  //token_api: "https://localhost:44345/",
  //token_api: "http://localhost:8082/",
  //ส่วน Config ระหว่าง Run Localhost กับ Doker

  //token_api: "http://doublep-docker.servehttp.com:8853/",
  //token_api: "http://doublep-docker.servehttp.com:9955/",
  //token_api: "https://localhost:44345/",

  //token_auth_api: "http://doublep-docker.servehttp.com:9955/api/AuthenticationDev"
  //token_auth_api: "http://doublep-docker.servehttp.com:9955/api/AuthenticationDemo"
  //token_auth_api: "http://doublep-docker.servehttp.com:9955/api/AuthenticationPRD"
  //token_auth_api: "http://doublep-docker.servehttp.com:9955/api/AuthenticationUAT"

  //ส่วน Config ระหว่าง Run Localhost กับ Doker
  // Dev
  token_auth_api: "https://pop-tokenapi-dev.double-p.co.th/api/AuthenticationDev", //เปิดอันนี้ run local
  // Prod
  //token_auth_api: "https://pop-tokenapi.double-p.co.th/api/AuthenticationPRD",
  //token_auth_api: "https://localhost:44345/api/AuthenticationDev",
  //token_auth_api: "http://localhost:8082/api/AuthenticationDev",
  //ส่วน Config ระหว่าง Run Localhost กับ Doker

  //token_auth_api: "http://doublep-cloud.servehttp.com:7781/api/AuthenticationDemo",
  //token_auth_api: "http://doublep-cloud.servehttp.com:7781/api/AuthenticationPRD",
  //token_auth_api: "http://doublep-cloud.servehttp.com:7781/api/AuthenticationUAT",
  //token_auth_api: "http://doublep-cloud.servehttp.com:7781/api/AuthenticationPartner",

  // Localhost + Dev
  token_auth_api_empservice: "https://pop-tokenapi-dev.double-p.co.th/api/AuthenticationPRD",
  // Prod
  //token_auth_api_empservice: "https://pop-tokenapi.double-p.co.th/api/AuthenticationPRD",
  //token_auth_api_empservice: "https://localhost:44345/api/AuthenticationPRD",
  //token_auth_api_empservice: "http://localhost:8082/api/AuthenticationPRD",

  //Expense System API
  //expense_base_api: "https://localhost:44365/", //Use this for Dev in Localhost
  // Localhost + Dev
  expense_base_api: "http://doublep-cloud.servehttp.com:4051/", //Change to this Before Deploy UAT
  // Prod
  //expense_base_api: "https://expense-base-api.double-p.co.th/"
  //expense_base_api: "https://localhost:44345/",
  //expense_base_api: "http://localhost:8082/", //Change to this Before Deploy UAT
  //expense_base_api: "http://doublep-cloud.servehttp.com:4053/",
};

export const AuthenSecretKey = {
  keyclient_id: "94f4cb9b-dc46-442a-8383-20e45392e98a",
  keytenantId: "1ab02cb3-85f4-4521-82e0-2854d9592ade",
  keyclient_secret: "zLS7Q~5gKFm-VhLX2cGHyk8GhV6TTJF5n8ZIh",
  response_type: "code",
  scope: "offline_access user.read mail.read",
  keyredirect_uri: "Authentication/GetGraphAuth"
}

export const ConstVariable = {
  PositionSaleModule: 1,
  PositionProjectModule: 2,
  PositionSupportModule: 3,

  ModuleSale: "1",
  ModuleProjectDelivery: "2",
  ModuleSupport: "3",
  Module3Axis: "4",
  ModuleMaster: "5"
};

// เพิ่มค่า MSAL สำหรับ Login + Graph API
// export const msalConfig = {
//     clientId: "ca64351d-fd05-4ab0-a5e5-05a5f6f9817c",        // ClientID จาก Azure
//     tenantId: "1ab02cb3-85f4-4521-82e0-2854d9592ade",        // TenantID จาก Azure
//     redirectUri: "http://localhost:62382/",  // Callback URL
//     scopes: ["User.Read", "Mail.Read", "Calendars.ReadWrite", "OnlineMeetings.ReadWrite", "offline_access"],
//     responseType: "code",
//   };

export const msalConfig = {
  auth: {
    clientId: "ca64351d-fd05-4ab0-a5e5-05a5f6f9817c",                             // ClientID จาก Azure
    redirectUri: "http://localhost:62382/"        // Callback URL
  },
  cache: {
    cacheLocation: "localStorage",               // เก็บ token ใน localStorage
    storeAuthStateInCookie: false                // true สำหรับ IE/Edge เก่า
  },
  scopes: [
    "User.Read", "Mail.ReadWrite", "Mail.Send", "Calendars.ReadWrite", "OnlineMeetings.ReadWrite", "offline_access"
  ],
  tenantId: "1ab02cb3-85f4-4521-82e0-2854d9592ade",
  responseType: "code"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
